import Script from 'next/script'

import { GTAG } from './config'

/**
 * GTM container bootstrap: Google's loader snippet plus the no-JS iframe
 * fallback. Renders nothing where GTAG is empty (localhost, test).
 */
const GtmScripts = () => {
  if (!GTAG) return null

  return (
    <>
      <Script
        id='gtm-init'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTAG}');
          `
        }}
      />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTAG}`}
          height='0'
          width='0'
          style={{ display: 'none', visibility: 'hidden' }}
          title='Google Tag Manager'
        ></iframe>
      </noscript>
    </>
  )
}

export default GtmScripts
